const billProjectionDataReducer = (state = null, action) => {
    switch (action.type) {
      case 'FETCH_BILL_PROJECTION_WIDGET_DATA_SUCCESS':{
        return{
        ...state,
        data:  action.payload};
      }
      case 'FETCH_BILL_PROJECTION_WIDGET_DATA_FAILED':{
        return{
        ...state,
        failed: true    
        };
      }
      default :{
        break;
      }
    }
    return state;
  }
  
  export default billProjectionDataReducer;
  